export function hardRefreshPage() {
    window.location.replace(window.location.href);
}

export function openGmailToAskForHelp() {
    const email= "operations@commenda.io";
    const subject = "Something went wrong – Need Help"

    const gmailLink = `https://mail.google.com/mail/?view=cm&fs=1&to=${email}&su=${encodeURIComponent(subject)}`;

    // Try opening mailto
    window.open(gmailLink, "_blank");
}
